module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_01 (2).88998c55.png";